import styled from 'styled-components'

export default styled.div`
    padding: ${props => (props.vOnly ? ' 2rem 0 3rem' : ' 2rem 2rem 3rem var(--pad4)')};
  max-width: 55rem;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
`